<template>
  <section>
    <section class="section">
      <div class="section-title">基础信息</div>
      <form-group title="机构性质" :field-validate-obj="$v.memberInfo.ITType">
        <radio-button-group name="ITType" :list="ittypeList" v-model="$v.memberInfo.ITType.$model"/>
      </form-group>
      <form-group title="单位名称（全称）" :field-validate-obj="$v.memberInfo.Name">
        <div class="input">
          <input type="text" placeholder="请输入单位全称" v-model="$v.memberInfo.Name.$model">
        </div>
      </form-group>
      <form-group title="申请本协会" :field-validate-obj="$v.memberInfo.MemType">
        <radio-button-group
          name="MemType"
          :list="memberTypeList"
          v-model="$v.memberInfo.MemType.$model"
        />
      </form-group>
      <form-group title="单位类别" :field-validate-obj="$v.memberInfo.Type">
        <div class="select">
          <select name id placeholder="请选择单位类别" v-model="$v.memberInfo.Type.$model">
            <option value>请选择单位类别</option>
            <option
              v-for="orgType in orgTypeList"
              name="orgType"
              :key="orgType.Id"
              :value="orgType.Id"
            >{{orgType.Name}}</option>
          </select>
          <i></i>
        </div>
      </form-group>
      <div class="label">
        <div class="label-title">
          单位地址
          <span class="rm">*</span>
        </div>
        <div class="select-group" style="margin-top:0.15rem;">
          <v-distpicker
            :placeholders="placeholders"
            @selected="onSelected"
            id="d1"
            @change="selectChange"
            :province="select.province"
            :city="select.city"
            :area="select.area"
          ></v-distpicker>
        </div>
      </div>
      <form-group title="详细地址" :field-validate-obj="$v.memberInfo.Address">
        <div class="input">
          <input type="text" placeholder="请填写单位地址" v-model="$v.memberInfo.Address.$model">
        </div>
      </form-group>
      <form-group title="成立日期" :field-validate-obj="$v.memberInfo.CreatedTime">
        <div class="input">
          <yd-datetime
            type="date"
            v-model="$v.memberInfo.CreatedTime.$model"
            start-year="2000"
            slot="right"
          />
        </div>
      </form-group>
      <form-group title="行业类别" :field-validate-obj="$v.memberInfo.IndustryType">
        <div class="select">
          <select name id placeholder="请选择所属行业" v-model="$v.memberInfo.IndustryType.$model">
            <option value>请选择所属行业</option>
            <option
              v-for="industryType in industryTypeList"
              name="orgType"
              :key="industryType.Id"
              :value="industryType.Id"
            >{{industryType.Name}}</option>
          </select>
          <i></i>
        </div>
      </form-group>
      <form-group title="职工人数" :field-validate-obj="$v.memberInfo.EmpNum">
        <div class="input">
          <input type="text" placeholder="请填写职工人数" v-model="$v.memberInfo.EmpNum.$model">
        </div>
      </form-group>
      <form-group title="大专学历以上人数" :field-validate-obj="$v.memberInfo.CollegeNumber">
        <div class="input">
          <input type="text" placeholder="请填写大专学历以上人数" v-model="$v.memberInfo.CollegeNumber.$model">
        </div>
      </form-group>
      <form-group title="博士人数" :field-validate-obj="$v.memberInfo.DoctorNumber">
        <div class="input">
          <input type="text" placeholder="请填写单位博士人数" v-model="$v.memberInfo.DoctorNumber.$model">
        </div>
      </form-group>
    </section>
    <section class="section">
      <div class="section-title">单位注册信息</div>
      <form-group title="统一信用代码" :field-validate-obj="$v.memberInfo.CreditCode">
        <div class="input">
          <input type="text" placeholder="请填写单位统一信用代码" v-model="$v.memberInfo.CreditCode.$model">
        </div>
      </form-group>

      <form-group title="注册资本" :field-validate-obj="$v.memberInfo.RegisteredCapital">
        <div class="input">
          <input
            type="text"
            placeholder="请填写单位注册资本"
            v-model="$v.memberInfo.RegisteredCapital.$model"
          >
        </div>
      </form-group>
      <form-group title="法定代表人" :field-validate-obj="$v.memberInfo.LegalRepresentative">
        <div class="input">
          <input
            type="text"
            placeholder="请填写单位法定代表人姓名"
            v-model="$v.memberInfo.LegalRepresentative.$model"
          >
        </div>
      </form-group>
      <form-group title="职务" :field-validate-obj="$v.memberInfo.Duties">
        <div class="input">
          <input type="text" placeholder="请填写职务" v-model="$v.memberInfo.Duties.$model">
        </div>
      </form-group>
      <form-group title="注册类型" :field-validate-obj="$v.memberInfo.SignType">
        <div class="select">
          <select name id placeholder="请选择注册类型" v-model="$v.memberInfo.SignType.$model">
            <option value>请选择注册类型</option>
            <option
              v-for="signType in signTypeList"
              name="orgType"
              :key="signType.Id"
              :value="signType.Id"
            >{{signType.Name}}</option>
          </select>
          <i></i>
        </div>
      </form-group>
      <form-group title="资产总额（万元）" :field-validate-obj="$v.memberInfo.TotalAssets">
        <div class="input">
          <input type="text" placeholder="请填写单位资产总额" v-model="$v.memberInfo.TotalAssets.$model">
        </div>
      </form-group>
      <form-group title="主营业务收入（万元）" :field-validate-obj="$v.memberInfo.MainBusinessIncome">
        <div class="input">
          <input
            type="text"
            placeholder="请填写单位主营业务收入"
            v-model="$v.memberInfo.MainBusinessIncome.$model"
          >
        </div>
      </form-group>
    </section>
    <section class="section">
      <!-- 模块标题 -->
      <div class="section-title">两化融合创新信息</div>
      <form-group title="高新技术企业" :field-validate-obj="$v.memberInfo.HighTechEnterprises">
        <checkbox-group
          name="HighTechEnterprises"
          :options="newHighTechEnterpriseList"
          exclusive-text="无"
          v-model="$v.memberInfo.HighTechEnterprises.$model"
        />
      </form-group>
      <form-group title="贯标情况" :field-validate-obj="$v.memberInfo.StandardCondition">
        <radio-button-group
          name="stand"
          :list="jitcSituationList"
          v-model="$v.memberInfo.StandardCondition.$model"
        />
      </form-group>
      <form-group title="示范企业" :field-validate-obj="$v.memberInfo.ModelEnterprise">
        <checkbox-group
          :options="modelEnterpriseList"
          name="modelEnterprise"
          exclusive-text="无"
          v-model="$v.memberInfo.ModelEnterprise.$model"
        />
      </form-group>
      <form-group title="示范批次、名称、年度" :field-validate-obj="$v.memberInfo.ModelBatchNameYear">
        <div class="input">
          <input
            type="text"
            placeholder="请填写示范批次、名称、年度"
            v-model="$v.memberInfo.ModelBatchNameYear.$model"
          >
        </div>
      </form-group>
      <form-group title="企业是否上云" :field-validate-obj="$v.memberInfo.IsCloud">
        <div class="radio-group clearfix">
          <radio-button
            text="是"
            value="true"
            name="isCloud"
            v-model="$v.memberInfo.IsCloud.$model"
          />
          <radio-button
            text="否"
            value="false"
            name="isCloud"
            v-model="$v.memberInfo.IsCloud.$model"
          />
        </div>
      </form-group>
      <form-group title="知识产权数量" :field-validate-obj="$v.memberInfo.IntellectualNumber">
        <div class="input">
          <input
            type="text"
            placeholder="请填写公司知识产权数量"
            v-model="$v.memberInfo.IntellectualNumber.$model"
          >
        </div>
      </form-group>
      <form-group title="主导制定技术标准" :field-validate-obj="$v.memberInfo.StandardTypeArray">
        <checkbox-group
          :options="standardTypeList"
          v-model="$v.memberInfo.StandardTypeArray.$model"
          exclusive="无"
          name="StandardTypeArray"
        />
      </form-group>
      <form-group title="研发机构" :field-validate-obj="$v.memberInfo.ResearchInstitutionLevelArray">
        <checkbox-group
          :options="researchTypeList"
          exclusive-text="无"
          size="100"
          v-model="$v.memberInfo.ResearchInstitutionLevelArray.$model"
          name="ResearchInstitutionLevelArray"
        />
      </form-group>
      <form-group title="上年度研发投入（单位：万元）" :field-validate-obj="$v.memberInfo.ResearchCost">
        <div class="input">
          <input type="text" placeholder="请填写金额" v-model="$v.memberInfo.ResearchCost.$model">
        </div>
      </form-group>
    </section>
    <section class="section">
      <div class="section-title">单位信息</div>
      <form-group title="单位简介" :field-validate-obj="$v.memberInfo.Summary">
        <div class="textarea">
          <textarea
            name
            id
            cols="30"
            rows="10"
            placeholder="请填写单位简介"
            v-model="$v.memberInfo.Summary.$model"
          ></textarea>
        </div>
      </form-group>
      <form-group title="本单位负责人" :field-validate-obj="$v.memberInfo.PrincipalName">
        <div class="input">
          <input type="text" placeholder="请填写单位负责人姓名" v-model="$v.memberInfo.PrincipalName.$model">
        </div>
      </form-group>
      <form-group title="本单位负责人电话" :field-validate-obj="$v.memberInfo.PrincipalTelephone">
        <div class="input">
          <input
            type="text"
            placeholder="请填写单位负责人电话号码"
            v-model="$v.memberInfo.PrincipalTelephone.$model"
          >
        </div>
      </form-group>
      <form-group title="本单位负责人手机" :field-validate-obj="$v.memberInfo.PrincipalMobilePhone">
        <div class="input">
          <input
            type="text"
            placeholder="请填写本单位负责人手机号码"
            v-model="$v.memberInfo.PrincipalMobilePhone.$model"
          >
        </div>
      </form-group>

      <form-group title="本单位负责人电子邮箱" :field-validate-obj="$v.memberInfo.PrincipalEmail">
        <div class="input">
          <input
            type="text"
            placeholder="请填写本单位负责人电子邮箱"
            v-model="$v.memberInfo.PrincipalEmail.$model"
          >
        </div>
      </form-group>
      <form-group title="CIO/IT负责人" :field-validate-obj="$v.memberInfo.CIOITName">
        <div class="input">
          <input type="text" placeholder="请填写CIO/IT负责人姓名" v-model="$v.memberInfo.CIOITName.$model">
        </div>
      </form-group>
      <form-group title="CIO/IT负责人电话" :field-validate-obj="$v.memberInfo.CIOITTelephone">
        <div class="input">
          <input
            type="text"
            placeholder="请填写CIO/IT负责人电话号码"
            v-model="$v.memberInfo.CIOITTelephone.$model"
          >
        </div>
      </form-group>
      <form-group title="CIO/IT负责人手机" :field-validate-obj="$v.memberInfo.CIOITMobilePhone">
        <div class="input">
          <input
            type="text"
            placeholder="请填写CIO/IT负责人手机号码"
            v-model="$v.memberInfo.CIOITMobilePhone.$model"
          >
        </div>
      </form-group>
      <form-group title="CIO/IT负责人电子邮箱" :field-validate-obj="$v.memberInfo.CIOITEmail">
        <div class="input">
          <input
            type="text"
            placeholder="请填写CIO/IT负责人电子邮箱"
            v-model="$v.memberInfo.CIOITEmail.$model"
          >
        </div>
      </form-group>
      <form-group title="日常联络人员" :field-validate-obj="$v.memberInfo.DailyContacctsName">
        <div class="input">
          <input
            type="text"
            placeholder="请填写日常联络人员姓名"
            v-model="$v.memberInfo.DailyContacctsName.$model"
          >
        </div>
      </form-group>
      <form-group title="日常联络人员电话" :field-validate-obj="$v.memberInfo.DailyContacctsTelephone">
        <div class="input">
          <input
            type="text"
            placeholder="请填写日常联络人员电话号码"
            v-model="$v.memberInfo.DailyContacctsTelephone.$model"
          >
        </div>
      </form-group>
      <form-group
        title="日常联络人员手机"
        :field-validate-obj="$v.memberInfo.DailyContacctsMobileTelephone"
      >
        <div class="input">
          <input
            type="text"
            placeholder="请填写日常联络人员手机号码"
            v-model="$v.memberInfo.DailyContacctsMobileTelephone.$model"
          >
        </div>
      </form-group>
      <form-group title="日常联络人员电子邮箱" :field-validate-obj="$v.memberInfo.DailyContacctsEmail">
        <div class="input">
          <input
            type="text"
            placeholder="请填写日常联络人员电子邮箱"
            v-model="$v.memberInfo.DailyContacctsEmail.$model"
          >
        </div>
      </form-group>
      <form-group title="企业营业执照副本扫描件" :field-validate-obj="$v.memberInfo.EnterpisePath">
        <upload-simple v-model="$v.memberInfo.EnterpisePath.$model"/>
      </form-group>
      <form-group title="法人身份证扫描件" :field-validate-obj="$v.memberInfo.LegalPath">
        <upload-simple v-model="$v.memberInfo.LegalPath.$model"/>
      </form-group>
    </section>

    <!-- END form elements -->
    <div class="foot-hint">
      备注：
      <br>1、申请表中涉及工商企业的指标，政府机构、大专院校、科研院所 不填。
      <!-- <br>2、请填写完整，之后打印、盖章，并将本文件电子档及扫描件、企 业营业执照副本扫描件、法人身份证扫描件发送至
      <br>
      <span>hangq@isip.org.cn</span>-->
    </div>
    <!-- MembershipRegisterProtocol -->
    <apply-modal
      v-if="isConstitutionShow"
      category="MembershipRegisterProtocol"
      @read="isConstitutionShow=false;isProtocolShow=true"
    />
    <!-- MembershipFeeManagementMethod -->
    <apply-modal
      v-show="isProtocolShow"
      category="MembershipFeeManagementMethod"
      @read="isProtocolShow=false"
    />

    <button
      class="btn-main btn-submit"
      @click="apply"
      :disabled="submitDisabled"
    >{{submitDisabled?'提交中..':'提交'}}</button>
    <footer-logo></footer-logo>
    <upload-progress v-if="uploadShow"></upload-progress>
  </section>
</template>

<script>
import footerLogo from '@/components/footerLogo.vue'
import uploadProgress from '@/components/uploadProgress.vue'
import VDistpicker from '@/components/distpicker.vue'
import applyModal from '@/components/member/applyModal.vue'
import RadioButtonGroup from '@/components/radioButtonGroup.vue'
import RadioButton from '@/components/RadioButton.vue'
import UploadSimple from '@/components/UploadSimple.vue'
import FormGroup from '@/components/formGroup.vue'
import CheckboxGroup from '@/components/CheckBoxGroup.vue'
import { required, minLength, between, email, numeric, decimal } from 'vuelidate/lib/validators'
import { isMobile, isPhone, number } from '@/helper/validateLib'

export default {
  components: {
    VDistpicker,
    'footer-logo': footerLogo,
    'upload-progress': uploadProgress,
    applyModal,
    RadioButton,
    RadioButtonGroup,
    UploadSimple,
    FormGroup,
    CheckboxGroup
  },
  data() {
    return {
      submitDisabled: false,
      uploadShow: false,
      isConstitutionShow: true,
      isProtocolShow: false,
      orgTypeList: [],
      industryTypeList: [],
      signTypeList: [],
      standardTypeList: [],
      researchTypeList: [],
      ittypeList: [],
      modelEnterpriseList: [],
      memberTypeList: [],
      newHighTechEnterpriseList: [],
      jitcSituationList: [],
      type: this.$route.query.type,
      areaALL: 'area',
      placeholders: {
        province: '省',
        city: '市',
        area: '区'
      },
      selectChange: false,
      select: {
        province: '',
        city: '',
        area: ''
      },
      memberInfo: {
        ITType: '',
        Name: '',
        MemType: '',
        Type: '',
        Address: '',
        CreatedTime: '2008-01-01',
        IndustryType: '',
        EmpNum: '',
        CollegeNumber: '',
        DoctorNumber: '',
        CreditCode: '',
        RegisteredCapital: '',
        LegalRepresentative: '',
        Duties: '',
        SignType: '',
        TotalAssets: '',
        TotalLiabilities: '',
        FixedAssets: '',
        LongtermLiabilities: '',
        BusinessConditions: '',
        MainBusinessIncome: '',
        Profit: '',
        Tax: '',
        HighTechEnterprises: [],
        StandardCondition: '',
        ModelEnterprise: [],
        ModelBatchNameYear: '',
        IsCloud: '',
        IntellectualNumber: '',
        MemType: '',
        ResearchCost: '',
        InformatizationCost: '',
        Summary: '',
        PrincipalName: '',
        PrincipalTelephone: '',
        CIOITName: '',
        CIOITTelephone: '',
        DailyContacctsName: '',
        DailyContacctsTelephone: '',
        EnterpisePath: '',
        LegalPath: '',
        AttPath: '',
        CIOITEmail: '',
        PrincipalMobilePhone: '',
        CIOITMobilePhone: '',
        DailyContacctsMobileTelephone: '',
        PrincipalEmail: '',
        DailyContacctsEmail: '',
        EnterprisePath: '',
        StandardTypeArray: [],

        ResearchInstitutionLevelArray: []
      },
      defaultImg: 'this.src="' + require('@/assets/images/defaultImg.png') + '"'
    }
  },
  validations: {
    areaALL: {
      required
      // requiredWhenValueNotEquals
    },
    memberInfo: {
      ITType: {
        required
      },
      Name: {
        required,
        minLength: minLength(2)
      },
      MemType: {
        required
      },
      Type: {
        required
      },
      Address: {
        required
      },
      CreatedTime: {
        required
      },
      IndustryType: {
        required
      },
      EmpNum: {
        required
      },
      CollegeNumber: {
        required
      },
      DoctorNumber: {
        required
      },
      CreditCode: {
        required
      },
      RegisteredCapital: {
        required
      },
      LegalRepresentative: {
        required
      },
      Duties: {
        required
      },
      SignType: {
        required
      },
      TotalAssets: {
        required
      },
      TotalLiabilities: {
        // required,
      },
      FixedAssets: {
        // required,
      },
      LongtermLiabilities: {
        //required,
      },
      BusinessConditions: {
        //required,
      },
      Profit: {
        //required,
      },
      Tax: {
        //required,
      },
      MainBusinessIncome: {
        required
      },

      HighTechEnterprises: {
        required
      },
      StandardCondition: {
        required
      },
      ModelEnterprise: {
        required
      },
      ModelBatchNameYear: {
        required
      },
      IsCloud: {
        required
      },
      IntellectualNumber: {
        required
      },
      MemType: {
        required
      },
      ResearchCost: {
        required,
        number
      },
      InformatizationCost: {
        // required,
      },
      Summary: {
        required
      },
      PrincipalName: {
        required
      },
      PrincipalTelephone: {
        required,
        isPhone
      },
      CIOITName: {
        required
      },
      CIOITTelephone: {
        required
      },
      CIOITEmail: {
        required,
        email
      },
      DailyContacctsName: {
        required
      },
      DailyContacctsTelephone: {
        required,
        isPhone
      },
      EnterpisePath: {
        required
      },
      LegalPath: {
        required
      },
      AttPath: {
        // required,
      },
      PrincipalMobilePhone: {
        required,
        isMobile
      },
      CIOITMobilePhone: {
        required,
        isMobile
      },
      DailyContacctsMobileTelephone: {
        required,
        isMobile
      },
      PrincipalEmail: {
        required,
        email
      },
      DailyContacctsEmail: {
        required,
        email
      },
      StandardTypeArray: {
        required
      },
      ResearchInstitutionLevelArray: {
        required
      }
    }
  },
  created() {
    // this.checkApply();
    this.initData()
    this.initMem()
    this.CreateMem()
  },
  methods: {
    initData() {
      this.loadDictionaryData('OrgType', 'orgTypeList')
      this.loadDictionaryData('IndustryType', 'industryTypeList')
      this.loadDictionaryData('SignType', 'signTypeList')
      this.loadDictionaryData('StandardType', 'standardTypeList')
      this.loadDictionaryData('ResearchType', 'researchTypeList')
      this.loadDictionaryData('ITType', 'ittypeList')
      this.loadDictionaryData('ModelEnterprise', 'modelEnterpriseList')
      this.loadDictionaryData('JitcSituation', 'jitcSituationList')
      this.loadDictionaryData('NewHighTechEnterprise', 'newHighTechEnterpriseList')

      this.$fetch('/api/Common/GetMemberTypeList').then(result => {
        this.memberTypeList = result
      })

      if (this.type == 'r') {
        console.log(this.type)
        this.$fetch('/api/OrganizationEnterprise/GetOrganizationApplyDetail')
          .then(result => {
            this.memberInfo = result
            this.select.province = result.ProvinceName
            this.select.city = result.CityName
            this.select.area = result.AreaName
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    loadDictionaryData(dataKey, memberName) {
      this.$fetch('/api/Common/GetDicList?value=' + dataKey).then(result => {
        this[memberName] = result
      })
    },
    apply() {
      console.log('submit')
      this.$v.$touch()
      if (this.$v.$invalid) {
        // var errors = []
        // for(var key in this.$v.memberInfo){
        //   if(this.$v.memberInfo[key].$error){
        //     errors.push(key)
        //   }
        // }

        this.$dialog.toast({
          // mes: "申请表验证失败，请检查。<br><strong>错误项列表:</strong><br>"+errors.join('<br>'),
          mes: '申请表验证失败，请检查。',
          timeout: 2500,
          icon: 'error'
        })
        return
      }

      this.submitDisabled = true
      this.$post('/api/OrganizationEnterprise/OrgEnterpriseApply', this.memberInfo)
        .then(result => {
          this.$dialog.toast({
            mes: '申请提交成功',
            timeout: 1500,
            icon: 'success'
          })
          this.$router.push({
            path: '/member/apply/wait'
          })
        })
        .catch(result => {
          this.$dialog.toast({
            mes: result.Error.Message,
            timeout: 1500,
            icon: 'error'
          })
        })
    },
    onSelected(data) {
      this.select.province = data.province.value
      this.select.city = data.city.value
      this.select.area = data.area.value
      this.areaALL = data.area.value
      this.memberInfo.ProvinceId = data.province.code
      this.memberInfo.CityId = data.city.code
      this.memberInfo.AreaId = data.area.code
    },
    CreateMem() {
      if (window.sessionStorage.getItem('memberInfo')) {
        var cacheData = JSON.parse(window.sessionStorage.getItem('memberInfo'))
        this.updateMemberInfo(cacheData)
      }
    },
    updateMemberInfo(memberData) {
      if (!memberData) return
      for (let name in memberData) {
        if (!this.$v.memberInfo[name]) {
          continue
        }

        let value = memberData[name]
        if (typeof value !== 'undefined' && value !== null) {
          if (typeof value === 'number') {
            this.$v.memberInfo[name].$model = value.toString()
          } else {
            this.$v.memberInfo[name].$model = value
          }
        } else {
          this.$v.memberInfo[name].$model = ''
        }
      }

      // update province+city+area info
      let province = memberData.ProvinceName
      let cityName = memberData.CityName
      let areaName = memberData.AreaName
      if (province) {
        this.select.province = province.toString()
      }
      if (cityName) {
        this.select.city = cityName.toString()
      }
      if (areaName) {
        this.select.area = areaName.toString()
      }
    },
    initMem() {
      var _this = this
      this.interval = setInterval(function() {
        //获取当前路由路径
        var path = window.location.pathname
        if (path != '/memberApply') {
          //清除定时器
          clearInterval(_this.interval)
          _this.interval = null
          console.log('清除定时器')
          return
        }
        window.sessionStorage.setItem('memberInfo', JSON.stringify(_this.memberInfo))
      }, 5000)
    },
    check_count: function(event) {
      var value = event.target.value
      if (!/^\+?[1-9][0-9]*$/.test(value)) {
        event.target.value = ''
      }
    },
    resetCardImage(type) {
      if (type == 1) {
        this.memberInfo.EnterpisePath = ''
      } else if (type == 2) {
        this.memberInfo.LegalPath = ''
      } else {
        this.memberInfo.AttPath = ''
      }
    },
    upLoadImg(el, type) {
      var _this = this
      var files = el.target.files
      var choosedFilesCount = files.length
      if (choosedFilesCount > 0) {
        var file = files[0]
        var formData = new FormData()
        formData.append('file', file, file.name)
        this.uploadShow = true
        this.$postImg('/api/Common/UploadFile', formData).then(result => {
          this.uploadShow = false
          if (type == 1) {
            _this.memberInfo.EnterpisePath = result
          } else if (type == 2) {
            _this.memberInfo.LegalPath = result
          } else {
            _this.memberInfo.AttPath = result
          }
        })
      }
    },
    checkApply() {
      this.$fetch('/api/OrganizationEnterprise/GetOrganizationAppplyStatus').then(result => {
        if (result == 3) {
          this.$router.push({
            path: '/member/apply/wait'
          })
        } else if (result == 4) {
          this.getPayStatus()
        }
      })
    },
    getPayStatus() {
      this.$fetch('/api/OrganizationEnterprise/GetPayStatus')
        .then(result => {
          if (result) {
            this.$router.push({
              path: '/member/pay/success'
            })
          } else {
            this.$router.push({
              path: '/member/apply/audit-success'
            })
          }
        })
        .catch(result => {})
    }
  }
}
</script>

<style lang="less" scoped>
.mat-10 {
  margin-top: 20 / @rem-size;
}

.section {
  width: 100%;
  height: auto;
  background: #fff;
  padding-bottom: 20 / @rem-size;

  .section-title {
    background: #f7f7f7;
    padding-left: 59 / @rem-size;
    line-height: 80 / @rem-size;
    font-size: 30 / @rem-size;
    color: #333;
    margin-top: 10 / @rem-size;
    position: relative;

    &::after {
      content: '';
      display: block;
      width: 0.04rem;
      height: 0.32rem;
      background: #005fd5;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 24 / @rem-size;
      margin: auto;
    }
  }

  .label {
    width: 100%;
    padding: 25 / @rem-size 24 / @rem-size 0;

    .label-title {
      font-size: 28 / @rem-size;
      color: #333;
    }
  }
}

.btn-submit {
  display: block;
  width: 360 / @rem-size;
  height: 80 / @rem-size;
  margin: auto;
  margin-top: 35 / @rem-size;
  border-radius: 8 / @rem-size;
  font-size: 28 / @rem-size;
}

.margin-left-10 {
  margin-left: 20 / @rem-size;
}

.border-20 {
  border-top: 20 / @rem-size solid #f7f7f7;
}

.rm {
  color: red;
}
</style>
